<template>
  <div class="zdh-check-box-wrapper">
    <label>
      <input type="checkbox" :name="name">
      <i></i>
      <span class="font1-12-333">{{text}}</span>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: "checkbox"
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'

  .zdh-check-box-wrapper
    font-size 0px
    position relative
    line-height 40px
    min-height 40px
    input[type="checkbox"]
      position absolute
      clip rect(0,0,0,0)
      &:checked + i
        background $themeColor3
        &:after
          content ""
          position absolute
          display block
          box-sizing border-box
          top: 4px;
          left: 3px;
          width: 9px;
          height: 6px;
          border-bottom: 2px solid #fff;
          border-left: 2px solid #fff;
          transform: rotate(-45deg);
        & + span
          color $themeColor3
    i
      display inline-block
      width 16px
      height 16px
      background #cccccc
      border-radius 50%
      position absolute
      top 50%
      margin-top: -8px;
      
    span 
      vertical-align middle 
      display inline-block
      margin-left 30px
      line-height 16px
</style>



// WEBPACK FOOTER //
// src/components/base/form/CheckBox.vue